
import Vue from 'vue';
import Config from '@/utils/config/index'
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
@Component
export default class UserForm extends Vue{

    @Prop({default:null})
    row:any;

    @Prop({default:false})
    readonly!:boolean;

    @Watch("row", { immediate: true })
    public watchRow() {
        if (this.row)
            this.Model = { ...this.row ,gender:this.row.gender?1:0,isDeleted:this.row.isDeleted?1:0 };
    }

    Action=`${Config.BASE_API}api/Uploads`;
    Folder=`${Config.BASE_API}upload`;
    Model = {
        userName: '',
        password: '',
        name: '',
        phone: '',
        departmentID: '',
        roleID: '',
        gender: 0,
        email: '',
        isDeleted: 0,
        avatar: null,
        signImg: null,
        introdution: ''
    }
    Clear(){
        this.Model = {
            userName: '',
            password: '',
            name: '',
            phone: '',
            departmentID: '',
            roleID: '',
            gender: 0,
            email: '',
            isDeleted: 0,
            avatar: null,
            signImg: null,
            introdution: ''
        }
    }
    FinishUploadAvatar(res: any) {
        if (res.status == 200) {
            this.Model.avatar = res.data;
        }
    }

    FinishUploadSign(res: any) {
        if (res.status == 200) {
            this.Model.signImg = res.data;
        }
    }
}
